const Financial = [
  {
    path: '/financial',
    name: 'Financial',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Resumo Financeiro',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/financial/Dashboard.vue`)
  },
  {
    path: '/new_movement',
    name: 'NewMovement',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Novo Lançamento',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/financial/NewMovement.vue`)
  },
  
]

export default Financial
